import { Box, Typography } from "@mui/material"
import type { ReactElement } from "react"
import React, { useCallback, useState } from "react"
import { useMutation } from "urql"

import { Button } from "@/components/common/Button"
import { InputField } from "@/components/common/InputField"
import type { UpdateLocationMutationMutation, UpdateLocationMutationMutationVariables } from "@/graphql/codegen/graphql"
import { UpdateLocationMutationDocument } from "@/graphql/codegen/graphql"
import ContactCardTitle from "@/screens/Companies/edit/components/locations/components/ContactCardTitle"

const Notes = ({ locationId, originalNotes }: { locationId: string; originalNotes?: string | null }): ReactElement => {
  const [notes, setNotes] = useState(originalNotes ?? "")
  const [isFullNoteVisible, setIsFullNoteVisible] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const isNoteShortAndVisible = (notes.length < 255 || isFullNoteVisible) && !isEditing

  const [, updateLocation] = useMutation<UpdateLocationMutationMutation, UpdateLocationMutationMutationVariables>(
    UpdateLocationMutationDocument
  )

  const handleSaveNote = useCallback(async () => {
    await updateLocation({
      input: {
        locationId,
        notes,
      },
    })
    setIsEditing(false)
  }, [updateLocation, locationId, notes])

  return (
    <Box className='mb-6 flex flex-col items-start p-4'>
      <ContactCardTitle title='Note' label='Edit Note' onClick={() => setIsEditing(true)} />
      {isEditing ? (
        <Box className='flex flex-col'>
          <InputField
            label=''
            placeholder='Add a note...'
            multiline
            className='h-auto p-4'
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            state='regular'
            endAdornment={
              <Button size='small' appearance='contained' onClick={handleSaveNote}>
                Add
              </Button>
            }
          />
        </Box>
      ) : (
        <Typography>
          {isNoteShortAndVisible ? (
            notes
          ) : (
            <>
              {`${notes.slice(0, 255)}...`}
              <Button
                variant='primary'
                appearance='text'
                className='ml-2 size-fit p-0 underline'
                onClick={() => setIsFullNoteVisible(true)}
              >
                Read more
              </Button>
            </>
          )}
        </Typography>
      )}
    </Box>
  )
}

export default Notes
